/*eslint-disable*/
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { ISelectValue } from 'constants/globalTypes'
import { generateWorkflow } from 'features/tasks/tasksSlice'
import { parseLocationRegistryOptions } from 'features/locationRegistry/locationRegistryMappers'
import { criteria } from 'pages/TaskTemplates/taskData'
import { ChangeEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { AppDispatch, RootState } from 'store'
import { Box, Button, Flex, H2, P, Separator, Title } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IAddTaskState } from 'types/tasks.interface'
import { formatDateForDisplay, getTimeFromDate } from 'utils/helpers'

export const WorkflowSection = ({
    handleChange,
    config,
    locations,
    setConfig,
    configRef,
    parseToolComponents
}: IWorkflowSection) => {
    const dispatch = useDispatch<AppDispatch>()
    const { generatedWorkflow } = useSelector((state: RootState) => state.tasks)

    const handleSelect = (v: ISelectValue, name: string, itemId?: number) => {
        setConfig((prev) => {
            const copy = { ...prev }
            const index = config.items.findIndex((i) => i.workflowTemplateItemId == itemId)
            config.items[index][name] = v
            return copy
        })
    }

    const handleValue = (e: ChangeEvent<HTMLInputElement>, itemId: number, componentId: number) => {
        setConfig((prev) => {
            const copy = { ...prev }
            const itemIndex = config.items.findIndex((i) => i.workflowTemplateItemId == itemId)
            const componentIndex = config.items[itemIndex].components.findIndex(
                (c) => c.id == componentId,
            )
            config.items[itemIndex].components[componentIndex].value = e.target.valueAsNumber

            return copy
        })
    }

    const handleGenerateWorkflow = async () => {
        try {

            if (!config.task || !config.criteria || config.items.some(i => (!i.location)) || config.items.some(i => i.components.filter(c => c.componentType == 1).some(c => !c.value))) {
                toast.warn('Please fill all fields')
                return
            }
            await dispatch(generateWorkflow(config))
            configRef.current.scrollTop = configRef.current.scrollHeight
        }

        catch (error) {
            console.log(error)
        }
    }


    const handleToolTypeComponents = (value: ISelectValue, name: string, itemId: number, taskTemplateToolTypeComponentId: number) => {
        setConfig(prev => {
            const copy = { ...prev }
            const index = prev.items.findIndex(i => i.id == itemId)
            copy.items[index][name] = { ...value, taskTemplateToolTypeComponentId }
            return copy
        })
    }

    const handleAmount = (e: ChangeEvent<HTMLInputElement>, itemId: number) => {
        const { valueAsNumber } = e.target
        setConfig(prev => {
            const copy = { ...prev }
            const index = copy.items.findIndex(i => i.id == itemId)
            copy.items[index].item.amount = valueAsNumber
            return copy
        })
    }

    return (
        <>
            <HonestSelectInput
                labelText='Criteria'
                options={criteria}
                onChange={handleChange}
                name='criteria'
                defaultValue={config?.criteria}
            />
            <HonestSelectAsyncInput
                nomarg
                link='departments'
                placeholder='Search department'
                name='department'
                labelText='Department'
                onChange={handleChange}
                parserFunction={(data: any) =>
                    data.data.map((i: any) => ({ label: i.name, value: i.id }))
                }
            />
            {config?.items?.map((i) => (
                <>
                    <H2 mb='10px'>{i.name}</H2>

                    <HonestSelectAsyncInput
                        nomarg
                        link='locations'
                        placeholder='Search locations'
                        name='component-location'
                        labelText='Location'
                        onChange={(v: ISelectValue) =>
                            handleSelect(v, 'location', i.workflowTemplateItemId)
                        }
                        parserFunction={parseLocationRegistryOptions}
                    />


                    {i.components
                        .filter((c) => c.componentType == 1)
                        .map((c) => (
                            <Input
                                placeholder='Enter value'
                                type='number'
                                labelText={c.name}
                                onChange={(e) => handleValue(e, i.workflowTemplateItemId, c.id)}
                                name={c.name}
                                value={c.value}
                            />
                        ))}
                    {i?.machine && <HonestSelectAsyncInput
                        name='machine'
                        labelText='Machinery'
                        onChange={(v, n) => handleToolTypeComponents(v, n, i.id, i.machine.taskTemplateToolTypeComponentId)}
                        link='machines'
                        parserFunction={parseToolComponents}
                    />}
                    {
                        i?.item && <Flex gap='1rem' >
                            <HonestSelectAsyncInput
                                name='item'
                                labelText='Item'
                                onChange={(v, n) => handleToolTypeComponents(v, n, i.id, i.item.taskTemplateToolTypeComponentId)}
                                link='inventory/item'
                                parserFunction={parseToolComponents}
                            />
                            <Input width='25%' labelText='Amount' onChange={e => handleAmount(e, i.id)} placeholder='5' type='number' value={i.item?.amount || 0} />
                        </Flex>
                    }
                </>
            ))}
            <Button orange onClick={handleGenerateWorkflow}>
                Generate
            </Button>
            {generatedWorkflow && (
                <>
                    <Separator />
                    <Flex column gap='1rem'>
                        <Title pad='0'>Generated Workflow Preview</Title>
                        <TextDisplayCard
                            labelText='Estimated cost'
                            title={generatedWorkflow.estimatedCost.toFixed(2)}
                        />
                        <Flex gap='1rem'>
                            <TextDisplayCard
                                width='100%'
                                labelText='Start'
                                title={
                                    formatDateForDisplay(generatedWorkflow.estimatedStartDate) +
                                    ' ' +
                                    getTimeFromDate(generatedWorkflow.estimatedStartDate)
                                }
                            />
                            <TextDisplayCard
                                width='100%'
                                labelText='End'
                                title={
                                    formatDateForDisplay(generatedWorkflow.estimatedEndDate) +
                                    ' ' +
                                    getTimeFromDate(generatedWorkflow.estimatedEndDate)
                                }
                            />
                        </Flex>
                        <H2 mb='0.5'>Tasks</H2>
                        {generatedWorkflow.items.map((i) => (
                            <Box>
                                <Flex column>
                                    <Flex between mb='10'>
                                        <TitleText weight='bold' >{i.taskTemplate.name}</TitleText>
                                        <BodyText weight='bold' >
                                            {getTimeFromDate(i.task.estimatedStartDate) +
                                                ' - ' +
                                                getTimeFromDate(i.task.estimatedEndDate)}
                                        </BodyText>
                                    </Flex>
                                    {i.task.userTasks.map((ut) => (
                                        <Flex key={ut.id} column>
                                            <Flex between>
                                                <P>{ut.fullName}</P>
                                                <P>
                                                    {getTimeFromDate(ut.estimatedStartDate) +
                                                        ' - ' +
                                                        getTimeFromDate(ut.estimatedEndDate)}
                                                </P>
                                            </Flex>
                                            {ut.executionPlans.length ? ut.executionPlans.map(ep => <P style={{ color: 'grey' }} key={ep.id} >{ep.machineName ?? 'No Machine'}</P>) : <P style={{ color: 'grey' }} >No Machine</P>}
                                        </Flex>
                                    ))}
                                </Flex>
                            </Box>
                        ))}
                    </Flex>
                </>
            )}
        </>
    )
}

interface IWorkflowSection {
    config: IAddTaskState
    handleChange: (value: ISelectValue, name: string) => void
    locations: ISelectValue[]
    setConfig: React.Dispatch<React.SetStateAction<IAddTaskState>>
    configRef: React.MutableRefObject<any>
    parseToolComponents: (r: any) => any

}
